// src/config/priceConfig.ts

// Structure pour les saisons et leurs périodes
export interface Season {
  name: string;       // Nom de la saison
  months: number[];   // Mois de l'année (1-12)
  pricePerNight: number; // Prix par nuit en euros
  description: string; // Description de la période
}

// Structure pour les périodes spéciales
export interface SpecialPeriod {
  name: string;       // Nom de la période spéciale (ex: "Noël", "Nouvel An")
  startDate: Date;    // Date de début de la période
  endDate: Date;      // Date de fin de la période
  pricePerNight: number; // Prix spécial par nuit
}

// Configuration des saisons et prix
export const seasons: Season[] = [
  {
    name: "Basse saison",
    months: [1, 2, 3, 11, 12],
    pricePerNight: 120,
    description: "Novembre - Mars"
  },
  {
    name: "Moyenne saison",
    months: [4, 5, 6, 9, 10],
    pricePerNight: 140,
    description: "Avril - Juin, Septembre - Octobre"
  },
  {
    name: "Haute saison",
    months: [7, 8],
    pricePerNight: 392,
    description: "Juillet - Août"
  }
];

// Configuration des périodes spéciales
export const specialPeriods: SpecialPeriod[] = [
  {
    name: "Noël et Nouvel An",
    startDate: new Date(2025, 11, 20), // 20 décembre 2025
    endDate: new Date(2026, 0, 5),     // 5 janvier 2026
    pricePerNight: 250
  },
  {
    name: "Pâques",
    startDate: new Date(2025, 3, 18),  // 18 avril 2025
    endDate: new Date(2025, 3, 22),    // 22 avril 2025
    pricePerNight: 220
  },
//   {
//     name: "Festival d'été",
//     startDate: new Date(2025, 6, 15),  // 15 juillet 2025
//     endDate: new Date(2025, 6, 25),    // 25 juillet 2025
//     pricePerNight: 750
//   }
];

// Fonction pour vérifier si une date est dans une période spéciale
export const isInSpecialPeriod = (date: Date): SpecialPeriod | null => {
  const specialPeriod = specialPeriods.find(
    period => date >= period.startDate && date <= period.endDate
  );
  return specialPeriod || null;
};

// Fonction pour obtenir le prix pour une date spécifique
export const getPriceForDate = (date: Date): { price: number; periodName?: string } => {
  // Vérifier d'abord si la date est dans une période spéciale
  const specialPeriod = isInSpecialPeriod(date);
  if (specialPeriod) {
    return { 
      price: specialPeriod.pricePerNight,
      periodName: specialPeriod.name
    };
  }
  
  // Sinon, utiliser le prix saisonnier standard
  const month = date.getMonth() + 1; // getMonth() retourne 0-11
  const season = seasons.find(season => season.months.includes(month));
  
  return { 
    price: season ? season.pricePerNight : 350,
    periodName: season ? season.name : "Basse saison"
  };
};
